import { HttpErrorResponse } from '@angular/common/http';

import { createActions, ngrxEvent } from '@recruitee/ngrx';

import {
  ViewboxConsentRequestActions,
  ViewboxConsentRequestData,
  ViewboxGdprData,
  ViewboxRequestBody,
} from './types';

const namespace = 'ViewboxGdpr';

export const ViewboxGdprActions = createActions(namespace, {
  loadItem: ngrxEvent<{ companyHost: string; candidateToken: string }>(),
  loadItemSuccess: ngrxEvent<ViewboxGdprData>(),
  loadItemFailed: ngrxEvent<{ error: HttpErrorResponse }>(),
  loadConsentRequestData: ngrxEvent<{ companyHost: string; consentToken: string }>(),
  loadConsentRequestDataSuccess: ngrxEvent<ViewboxConsentRequestData>(),
  loadConsentRequestDataFailed: ngrxEvent<{ error: HttpErrorResponse }>(),
  newRequest: ngrxEvent<{
    companyHost: string;
    candidateToken: string;
    body?: ViewboxRequestBody;
  }>(),
  newRequestSuccess: ngrxEvent<ViewboxGdprData>(),
  newRequestFailed: ngrxEvent<{ error: HttpErrorResponse }>(),
  consentRequest: ngrxEvent<{
    action: Omit<ViewboxConsentRequestActions, ViewboxConsentRequestActions.Confirm>;
    companyHost: string;
    consentToken: string;
  }>(),
  consentRequestSuccess: ngrxEvent<ViewboxConsentRequestData>(),
  consentRequestFailed: ngrxEvent<{ error: HttpErrorResponse }>(),
});
